/* ===========================================================================
   A PÁGINA DOS CUPÕES · Ilha dos Cosméticos · Proa, 27/09/2026
   ---------------------------------------------------------------------------
   Só faz uma coisa: deixa as secções entrarem quando chegam ao ecrã.

   ⛔ A página nasce VISÍVEL. É este ficheiro que lhe põe a classe que a esconde,
   e só depois de confirmar que o IntersectionObserver existe. Uma página parada
   em `opacity:0` à espera de JavaScript é uma página em branco no dia em que o
   JavaScript falhar, e uma página de condições em branco é pior do que nenhuma.

   ⚠️ E revela à força o que já estiver no ecrã quando a página abre, para o caso
   de alguém chegar por uma âncora ou com o scroll já a meio: sem isso, um salto
   direto deixava a secção invisível. Apanhei-o a provar a página.

   (O verificador produto a produto saiu a 27/09 por ordem do Silva: a página
   fala por marcas, que é o que a cliente tem na cabeça.)
   =========================================================================== */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-cup]');
  if (!raiz) return;
  if (!('IntersectionObserver' in window)) return;

  var alvos = raiz.querySelectorAll('[data-revelar]');
  if (!alvos.length) return;

  Array.prototype.forEach.call(alvos, function (el) { el.classList.add('cup-revelar'); });

  var olho = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('cup-visivel');
      olho.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  Array.prototype.forEach.call(alvos, function (el) { olho.observe(el); });

  // rede de segurança: passados 3 segundos, o que ainda estiver escondido aparece.
  // ⛔ Nenhuma frase desta página pode depender de um observador ter disparado.
  setTimeout(function () {
    Array.prototype.forEach.call(alvos, function (el) { el.classList.add('cup-visivel'); });
  }, 3000);
})();
